import { DetailedHTMLProps, forwardRef, InputHTMLAttributes } from 'react';
import ChoiceInput from './ChoiceInput';

type ICheckboxProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

const Checkbox = forwardRef<HTMLInputElement, ICheckboxProps>(function Checkbox(props, ref) {
    return <ChoiceInput {...props} ref={ref} type='checkbox' />;
});

export default Checkbox;
